var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlicedSection',{staticClass:"pricing-qa",attrs:{"single-column":"","custom-class":"bordered-bottom"}},[_c('questions-list')],1)}
var staticRenderFns = []
export { render, staticRenderFns }